import { Box, styled } from '@mui/material';

export const ValueSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-end',
  gap: '4px',
  fontSize: '10px',
  lineHeight: 'normal',
  letterSpacing: 'normal',
  color: theme.palette.colors.lower,
}));
